import { Component } from '@angular/core';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [CardModule],
  template: `
    <div class="dashboard">
      <h1>Admin Dashboard</h1>
      <p-card>
        <p>Welcome to CanvasBloom Admin Panel!</p>
        <p>Use the navigation menu to manage your e-commerce platform.</p>
      </p-card>
    </div>
  `,
  styles: [`
    .dashboard h1 {
      margin-bottom: 1.5rem;
      color: var(--text-color);
    }
  `]
})
export class AdminDashboardComponent {}
